import React, { useState, useContext } from 'react';
import axios from 'axios';
import { ChatContext } from '../../../createContext/Chat/ChatContext';

const industryOptions = [
  "Technology", "Banking and Financial Services", "Consulting", 
  "Insurance", "Government", "Legal Services", "Hospitality", 
  "Airlines and Aviation", "Healthcare", "Engineering", "Education", 
  "Non Profit", "Media", "Defense", "Manufacturing", "Farming", 
  "Human Resources", "Finance", "Supply Chain", "Customer Service", 
  "Marketing and Advertising", "Sales", "Player"
];

const passionOptions = [
  "Football", "Basketball", "Baseball", "Soccer", "Tennis",
  "Volleyball", "Softball", "Hockey", "Rugby", "Cricket",
  "Pickle", "Padel"
];

const CreateCommunityModal = ({ isOpen, onClose, onCommunityCreated }) => {
  const { token } = useContext(ChatContext);
  const [communityData, setCommunityData] = useState({
    name: '',
    description: '',
    industry: '',
    location: '',
    privacy: 'public',
    passions: []
  });

  const [currentPassion, setCurrentPassion] = useState({
    name: '',
    skillLevel: 'Beginner'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCommunityData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const addPassion = () => {
    if (currentPassion.name.trim()) {
      setCommunityData(prev => ({
        ...prev,
        passions: [...prev.passions, currentPassion]
      }));
      setCurrentPassion({ name: '', skillLevel: 'Beginner' });
    }
  };

  const removePassion = (index) => {
    setCommunityData(prev => ({
      ...prev,
      passions: prev.passions.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_CHAT_URL}/api/communities/create`, 
        communityData,
        { headers: { token } }
      );
      onCommunityCreated(response.data.community);
      setCommunityData({ name: '', description: '', industry: '', location: '', privacy: 'public', passions: [] });
      onClose();
    } catch (error) {
      console.error('Error creating community:', error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[5000000]">
      <div className="bg-white overflow-auto max-h-full p-8 rounded-lg w-full max-w-2xl scrollbar-hide">
        <h2 className="text-2xl font-bold mb-6">Create a New Community</h2>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block mb-2">Community Name</label>
            <input type="text" name="name" value={communityData.name} onChange={handleInputChange} className="w-full p-2 border rounded" required />
          </div>
          <div>
            <label className="block mb-2">Industry</label>
            <select name="industry" value={communityData.industry} onChange={handleInputChange} className="w-full p-2 border rounded" required>
              <option value="">Select Industry</option>
              {industryOptions.map(industry => (<option key={industry} value={industry}>{industry}</option>))}
            </select>
          </div>
          <div className="md:col-span-2">
            <label className="block mb-2">Description</label>
            <textarea name="description" value={communityData.description} onChange={handleInputChange} className="w-full p-2 border rounded" required />
          </div>
          <div>
            <label className="block mb-2">Location</label>
            <input type="text" name="location" value={communityData.location} onChange={handleInputChange} className="w-full p-2 border rounded" required />
          </div>
          <div>
            <label className="block mb-2">Privacy</label>
            <select name="privacy" value={communityData.privacy} onChange={handleInputChange} className="w-full p-2 border rounded">
              <option value="public">Public</option>
              <option value="private">Private</option>
            </select>
          </div>
          <div className="md:col-span-2">
            <label className="block mb-2">Passions</label>
            <div className="flex mb-2">
              <select value={currentPassion.name} onChange={(e) => setCurrentPassion(prev => ({ ...prev, name: e.target.value }))} className="w-1/2 p-2 border rounded mr-2">
                <option value="">Select Passion</option>
                {passionOptions.map(passion => (
                  <option key={passion} value={passion}>{passion}</option>
                ))}
              </select>
              <select value={currentPassion.skillLevel} onChange={(e) => setCurrentPassion(prev => ({ ...prev, skillLevel: e.target.value }))} className="w-1/2 p-2 border rounded">
                <option value="Beginner">Beginner</option>
                <option value="Foundation">Foundation</option>
                <option value="Intermediate">Intermediate</option>
                <option value="Advance">Advance</option>
                <option value="Pro">Pro</option>
              </select>
              <button type="button" onClick={addPassion} className="ml-2 bg-black text-white p-2 rounded">Add</button>
            </div>
            <div className="flex flex-wrap">
              {communityData.passions.map((passion, index) => (
                <span key={index} className="bg-gray-200 p-1 m-1 rounded flex items-center">
                  {passion.name} ({passion.skillLevel})
                  <button type="button" onClick={() => removePassion(index)} className="ml-2 text-red-500">×</button>
                </span>
              ))}
            </div>
          </div>
          <div className="md:col-span-2 flex justify-end">
            <button type="button" onClick={onClose} className="mr-4 bg-gray-300 p-2 rounded">Cancel</button>
            <button type="submit" className="bg-black text-white p-2 rounded">Create Community</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCommunityModal;